<template>
  <div
    class="flex max-lg:flex-col items-center flex-row justify-between gap-10 lg:gap-20 lg:*:w-1/2"
  >
    <div class="w-full max-w-3xl h-auto mx-auto">
      <!-- If image is a webm video -->
      <video
        v-if="isWebm"
        :src="data?.image"
        autoplay
        muted
        loop
        playsinline
        :width="width ?? 452"
        :height="height ?? 521"
        class="w-full h-auto [box-shadow:0_2rem_3rem_-1rem_rgba(105,124,161,0.16),0_0_0_0.5rem_#fff] rounded-2xl"
      ></video>

      <!-- Otherwise use NuxtImg -->
      <NuxtImg
        v-else
        :src="data?.image"
        :alt="data.heading ?? 'Service Image'"
        class="w-full h-auto [box-shadow:0_2rem_3rem_-1rem_rgba(105,124,161,0.16),0_0_0_0.5rem_#fff] rounded-2xl"
        loading="lazy"
        format="webp"
        :width="width ?? 452"
        :height="height ?? 521"
      />
    </div>
    <div class="">
      <p class="text-xl md:text-2xl font-semibold">
        {{ data?.small_heading }}
      </p>
      <h2 class="mb-2 max-md:mb-4 md:mb-4">
        <WrGradientText
          :text="data?.main_heading"
          append-class="pb-0 md:pb-2 bg-clip-text bg-[linear-gradient(92.15deg,_var(--text-gradient-1)_-1.57%,_var(--text-gradient-2)_30.72%)]"
        />
      </h2>
      <div
        class="lg:text-lg tracking-[0.5px] leading-[1.8] mt-8"
        v-html="data?.sub_text"
      ></div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  data: Object,
  width: {
    type: String,
    default: "565",
  },
  height: {
    type: String,
    default: "423",
  },
});

const isWebm = computed(() =>
  props.data?.image?.toLowerCase().endsWith(".webm")
);
</script>

<style lang="scss" scoped></style>
